<template>
    <div class="card">
        <h3>{{ this.headline }}</h3>
        <slot/>
    </div>
</template>

<script>
export default {
    props: {
        headline: String,
        body: String
    }

}
</script>

<style lang="scss">

$blue: #B1D0E3;
$dark-blue: #7FAAC3;
$light-blue: #dbecf6;
$grey: #757575;
$light-grey: #e8e8e8;

.card {
    margin: 10px;
    padding: 15px;
    max-width: 500px;

    box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.2);
}

</style>
